import Swiper from "swiper/bundle";
import { smootherPause } from "./smoother";

export const leadspaceWithSliderAndText = () => {
    const select = document.querySelector('.leadspace-with-slider-and-text');
    const slider = select.querySelector('.leadspace-with-slider-and-text__swiper');
    const carousel = select.querySelector('.leadspace-with-slider-and-text__swiper-pagination');
    const captions = select.querySelectorAll('.leadspace-with-slider-and-text__single-caption');
    let swiper = new Swiper(slider, {
        preloadImages: false,
        lazy: true,
        speed: 600,
        autoplay: {
            delay: 2000
        },
        pagination: {
            el: carousel,
            clickable: true
        },
        on: {
            slideChange: () => {
                captions.forEach( e => 
                    e.classList.contains('leadspace-with-slider-and-text__single-caption--active') ?
                    e.classList.remove('leadspace-with-slider-and-text__single-caption--active') : ''
                );
                setTimeout(() => {
                    captions[swiper.activeIndex].classList.add('leadspace-with-slider-and-text__single-caption--active')
                }, 300)
            },
            sliderMove: () => {
                smootherPause(true);
            },
            touchEnd: () => {
                smootherPause(false);
            }
        }
    })
}
